import httpService from './httpService';
import { removeToken } from './cookieService';
import { getLockeConfig } from './lockeService';
import { LockeClientId } from '../types';

export const isLockeAuthenticated = async (
  token: string | undefined,
  lockeClientId: LockeClientId,
): Promise<boolean> => {
  try {
    const requestHeaders = (): HeadersInit => {
      const headers = new Headers();
      token && headers.append('token', token);
      headers.append('cache-control', 'no-cache');
      return headers;
    };
    const options: RequestInit = {
      ...requestHeaders,
      credentials: 'include',
    };

    const { rcaApiHost } = getLockeConfig(lockeClientId);

    const response = await httpService(
      `${rcaApiHost}/myaccount/user-profile`,
      options,
    );

    const { status } = response;

    if (status === 400 || status === 401) {
      removeToken();
      return false;
    }

    if (status >= 500) {
      console.log(
        'There is an error while fetching the user profile',
        response,
      ); //TODO: Proper error handling
      return false;
    }
  } catch (error) {
    console.log(error);
    return false;
  }
  return true;
};
